import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  focused: {
    color: 'hsla(225, 19%, 60%, 1)'
  }
}));
